import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Button from "../../common/Button";
import { downloadTestFeedback, testFeedbackUrl } from "../../api/profileApi";
import {
  isDownloadAttrSupported,
  forceDownload,
} from "../../containers/ResourceFolders/util";

const downloadFeedback = async (testName) => {
  if (isDownloadAttrSupported()) {
    return downloadTestFeedback(testName).then((response) =>
      forceDownload(response, "DISCAssessmentTestFeedback.pdf")
    );
  }
  return window.open(testFeedbackUrl(testName), "_blank");
};
const DiscAssessmentTestIndex = ({ appData }) => {
  return (
    <article>
      <div className="styles__resource__wrapper___EooDq">
        <h4 className="styles__resource__title___3swKq">
          DISC Assessment Test
        </h4>
        <p className="styles__resource__description___2yhR0">
          <b>
            DISC is a popular psychology personality based test based on four
            personality types. The DISC system is mostly used with a focus on
            employment or team building. The roots of DISC was a book published
            in 1928, titled Emotions of Normal People. The author William
            Marston theorized that a person would express their emotions in one
            of four ways, from which the four letters &quot;D I S C&quot; are
            derived. In the 1950s a series of industrial psychologists used his
            theory as the basis of a tool for employee selection and
            organization.
            <br />
            <br />
            Today there are many tests that exist under the name DISC, marketed
            by various psychological consulting companies for use by human
            resource departments, each with their own differences.
            <br />
            <br />
            This DISC assessment test has 16 statements. You must rate on a five
            point scale on how much you agree with each statement. The test
            should take 4-6 minutes to complete.
            <br />
            <br />
            This test is provided for educational use only. It should not be
            used as psychological advice of any kind and comes without any
            guarantee of accuracy or fitness for any particular purpose.
            <br />
            <br />
            In taking this test, you consent to HRGO storing and processing the
            information you provide in order to provide you with the test
            result. The information you provide may also be used to find the
            most suitable job for you, to share with clients, train our data
            models, improve and iterate these tests, and provide you with the
            most relevant advertising and courses. Where the data does not
            require attribution; we will anonymise your information for
            processing.
            <br />
            <br />
            {appData.discAssessmentTestHandling
              ? " Please click Download to get your feedback."
              : " Please click Launch to complete this test."}
          </b>
        </p>
        <div className="d-flex flex-column">
          {appData.discAssessmentTestHandling ? (
            <Button
              onClick={() => {
                downloadFeedback("discAssessment");
              }}
              id="btnBasicInfoEditSubmit"
              classes="btn btn-primary ml-auto"
            >
              Download
            </Button>
          ) : (
            <Link
              to="/profile/MyTests/DISCAssessment"
              className="btn btn-primary ml-auto"
            >
              Launch
            </Link>
          )}
        </div>
      </div>
    </article>
  );
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, null);
export default withRedux(DiscAssessmentTestIndex);
